/* Builder B’s typed hooks for WF-14 — the shared transport of src/lib/api.ts
   (`get`), query-key style as there, in this folder per the ruling of 30/08. */
import { useQuery } from '@tanstack/react-query'
import { get } from '@/lib/api'

export interface StatusCell { tone: 'ok' | 'warn' | 'crit' | 'ink'; mark?: string; label: string }

/* WF-14 · multi-location ops — ML-01…ML-08.
   Values only; every label, note and button caption is verbatim in the screen. */
export interface MultiLocation {
  setup: { n: string; strong: string[]; meta?: string; mark: StatusCell | null }[]
  csv: {
    ready: string
    rows: { title: string; meta: string; actions: string[] }[]
  }
  groups: { title: string; meta: string }[]
  readiness: {
    crumb: string
    columns: string[]
    rows: { name: string; cells: (string | StatusCell)[] }[]
  }
  waves: { title: string; meta: string; status?: StatusCell; action?: string }[]
  compare: {
    columns: string[]
    rows: string[][]
    actions: string[]
  }
  apply: {
    title: string
    inheritance: string
    exception: { title: string; meta: string; status: StatusCell }
  }
  result: {
    title: string
    badge: StatusCell
    rows: { title: string; meta: string; action: string }[]
  }
}

export const useMultiLocation = () =>
  useQuery({ queryKey: ['multi-location'], queryFn: () => get<MultiLocation>('/etablissements/multi') })
